import dayjs from "dayjs"

const application_form = ({
	holderSalutation,
	holderName,
	holderHKID,
	holderDOB,
	holderAddress,
	holderEmail,
	holderContact,
	otherHolders,
	insuredName,
	insuredHKID,
	insuredDOB,
	insuredGender,
	insuredHeight,
	insuredWeight,
	insuredOccupation,
	insuredRelationship,
	insuredPlaceOfResidence,
	insuredFacts
}) => {
	return `
  <!DOCTYPE html>

<html lang="en" xmlns="http://www.w3.org/1999/xhtml">

<head>
  <meta charset="utf-8" />
  <title>VHIS_Standard_Plan_-_Application_Form</title>
  <style>
    .ff-msjh {
      font-family: "Droid Sans";
    }

    .new-page {
      page-break-before: always;
    }

    .header__container {
      float: left;
      display: block;
      width: 100%;
      margin: 0 0 25px 0;
    }

    .header__image {
      width: 100%;
    }
  </style>
</head>

<body>
  
  <div style="margin: 0 auto;">
    <div>
      <p>
        <h3>Personal Information of Representative Policy Holder <span class="ff-msjh">個人資料 - 第一保單持有人 </span>
        </h3>
        Salutation <span class="ff-msjh">稱呼</span>: ${
					holderSalutation
						? holderSalutation.charAt(0).toUpperCase() +
						  holderSalutation.slice(1)
						: "N/A"
				}
        <br>
        Full Name <span class="ff-msjh">姓名</span>: ${holderName}
        <br>
        HKID Number <span class="ff-msjh">香港身份證號碼</span>: ${holderHKID}
        <br>
        Date of Birth (DD/MM/YYYY) <span class="ff-msjh">出生日期</span>: ${holderDOB}
        <br>
        Correspondence Address <span class="ff-msjh">通訊地址</span>: ${holderAddress}
        <br>
        Personal Email Address <span class="ff-msjh">個人電郵地址</span>: ${holderEmail}
        <br>
        Contact Telephone No. <span class="ff-msjh">聯絡電話</span>: ${holderContact}
      </p>
    </div>

    <br>
    <div>
      <p>
        <h3>Proposed Insured Person Details <span class="ff-msjh">準受保人資料</span></h3>
        Full Name <span class="ff-msjh">姓名</span>: ${insuredName}
        <br>
        HKID Number <span class="ff-msjh">香港身份證號碼</span>: ${insuredHKID}
        <br>
        Date of Birth <span class="ff-msjh">出生日期</span>: ${insuredDOB}
        <br>
        Gender <span class="ff-msjh">性別</span>: ${insuredGender}
        <br>
        Height <span class="ff-msjh">身高</span>: ${insuredHeight}cm
        <br>
        Weight <span class="ff-msjh">體重</span>: ${insuredWeight}kg
        <br>
        Occupation <span class="ff-msjh">職業</span>: ${insuredOccupation}
        <br>
        Relationship to the Policy Holder(s) <span class="ff-msjh">與保單持有人的關係</span>:
        ${insuredRelationship}
        <br>
        Place of Residence <span class="ff-msjh">居住地</span>: ${insuredPlaceOfResidence}
      </p>
    </div>

    <br>
    ${otherHolders
			.map(item => {
				return `
          <div>
          <p>
          <h3>Personal Information of Other Policy Holder 個人資料 - 其他保單持有人</h3>
          Salutation <span class="ff-msjh">稱呼</span>: ${
						item.salutation
							? item.salutation.charAt(0).toUpperCase() +
							  item.salutation.slice(1)
							: "N/A"
					}
          <br>
          Full Name <span class="ff-msjh">姓名</span>: ${item.name}
          <br>
          HKID Number <span class="ff-msjh">香港身份證號碼</span>: 
          ${
						item.identities
							? item.identities
									.filter(identity => identity.type === "hkid")
									.map(identity => identity.value)
							: "N/A"
					}
          <br>
          Date of Birth (DD/MM/YYYY) <span class="ff-msjh">出生日期</span>: 
          ${dayjs(item.dateOfBirth).format("DD/MM/YYYY")}
          <br>
          Correspondence Address <span class="ff-msjh">通訊地址</span>: ${
						item.addresses
							? item.addresses
									.filter(item => item.type === "correspondenceAddress")
									.map(item => {
										const fields = JSON.parse(item.fields)
										return fields.correspondenceAddress
									})
							: "N/A"
					}
          <br>
          Personal Email Address <span class="ff-msjh">個人電郵地址</span>: 
          ${
						item.contacts
							? item.contacts
									.filter(contact => contact.type === "email")
									.map(contact => contact.value)
							: "N/A"
					}
          <br>
          Contact Telephone No. <span class="ff-msjh">聯絡電話</span>: ${
						item.contacts
							? item.contacts
									.filter(contact => contact.type === "telephoneNumber")
									.map(contact => contact.value)
							: "N/A"
					}
          </p>
          </div>`
			})
			.join("<br>")}
      
    <div class="new-page"></div>
    

    <div>
      <h3>Health Statement of the Proposed Insured Person <span class="ff-msjh">準受保人病歷聲明</span> </h3>
      <p>
        1. Has the proposed Insured Person ever suffered from, aware of or been treated for any sickness or any
        abnormal medical condition(s)? <span class="ff-msjh">準受保人是否患有、已知道存在或曾經接受治療以下疾病及不正常的身體狀況？ 請選擇適用的項目</span>
        <br>
        Cancer or tumour of any kind <span class="ff-msjh">各類型癌症或腫瘤</span>: ${insuredFacts
					.filter(item => item.type === "hasCancer")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Disorder of the skin, bones, glands, eyes or ears <span class="ff-msjh">皮膚、骨、腺、眼或耳之疾病</span>:
        ${insuredFacts
					.filter(item => item.type === "hasSkinDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Asthma or any kind of respiratory disorder <span class="ff-msjh">氣喘病或各類型呼吸疾病</span>:
        ${insuredFacts
					.filter(item => item.type === "hasRespiratoryDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Deviated nasal septum (or turbinates) <span class="ff-msjh">鼻中隔或鼻甲骨偏側</span>:
        ${insuredFacts
					.filter(item => item.type === "hasDeviatedNasalSeptum")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Raised, spat blood, or tuberculosis <span class="ff-msjh">吐血、血痰或結核病</span>: ${insuredFacts
					.filter(item => item.type === "hasTuberculosis")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Thyroid disorder, Lymph node enlargement <span class="ff-msjh">甲狀腺病、淋巴結腫大</span>:
        ${insuredFacts
					.filter(item => item.type === "hasThyroidDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Hepatitis or hepatitis carrier <span class="ff-msjh">肝炎或肝炎帶菌者</span>: ${insuredFacts
					.filter(item => item.type === "hasHepatitis")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Any kind of liver disorder, fatty liver, cirrhosis <span class="ff-msjh">各類型肝疾病、脂肪肝、肝硬化</span>:
        ${insuredFacts
					.filter(item => item.type === "hasLiverDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Malaria <span class="ff-msjh">瘧疾</span>: ${insuredFacts
					.filter(item => item.type === "hasMalaria")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Varicose Veins <span class="ff-msjh">靜脈曲張</span>: ${insuredFacts
					.filter(item => item.type === "hasVaricoseVeins")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Fainting, Vertigo <span class="ff-msjh">昏厥、暈眩</span>: ${insuredFacts
					.filter(item => item.type === "hasVertigo")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Epilepsy <span class="ff-msjh">腦癇症</span>: ${insuredFacts
					.filter(item => item.type === "hasEpilepsy")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Cerebrovascular disorder, stroke, CVA <span class="ff-msjh">腦血管功能失常、中風</span>:
        ${insuredFacts
					.filter(item => item.type === "hasCerebrovascularDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Diabetes <span class="ff-msjh">糖尿病</span>: ${insuredFacts
					.filter(item => item.type === "hasDiabetes")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Hypertension, hyperlipidemia, hypercholesterolemia <span class="ff-msjh">高血壓、高脂血症、高膽固醇血症</span>:
        ${insuredFacts
					.filter(item => item.type === "hasHypertension")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Chest pain, angina <span class="ff-msjh">胸口痛、心絞痛</span>: ${insuredFacts
					.filter(item => item.type === "hasChestPain")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Cardiovascular or circulatory disorder <span class="ff-msjh">心臟血管或循環系統疾病</span>:
        ${insuredFacts
					.filter(item => item.type === "hasCardiovascularDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Any kind of heart disorder, arrhythmias, heart failure 各類型心臟病、心律不正、心臟衰竭: ${insuredFacts
					.filter(item => item.type === "hasHeartDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Ulcer of any kind <span class="ff-msjh">各類型潰瘍症</span>: ${insuredFacts
					.filter(item => item.type === "hasUlcer")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Digestive, esophagus, gastrointestinal tract disorder <span class="ff-msjh">消化系統、食道、腸胃疾病</span>:
        ${insuredFacts
					.filter(
						item =>
							item.type === "hasDigestiveEsophagusGastrointestinalTractDisorder"
					)
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Haemorrhoids, anal fistulae <span class="ff-msjh">痔瘡、肛瘻</span>: ${insuredFacts
					.filter(item => item.type === "hasHaemorrhofieldIds")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Hernia <span class="ff-msjh">疝氣</span>: ${insuredFacts
					.filter(item => item.type === "hasHernia")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Stone, renal failure or any kind of kidney disorder <span class="ff-msjh">腎石、腎功能衰竭、各類型腎病</span>:
        ${insuredFacts
					.filter(item => item.type === "hasKidneyDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Hallux Valgus <span class="ff-msjh">姆趾外翻</span>: ${insuredFacts
					.filter(item => item.type === "hasHalluxValgus")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Autoimmune disorder <span class="ff-msjh">自體免疫性疾病</span>: ${insuredFacts
					.filter(item => item.type === "hasAutoimmuneDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Any kind of blood disorder, anemia, thalassemia, leukemia <span class="ff-msjh">各類型血液疾病、貧血、地中海貧血、白血病</span>:
        ${insuredFacts
					.filter(item => item.type === "hasBloodDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Spinal or muscular skeletal conditions/disorder <span class="ff-msjh">脊椎或肌肉及骨骼病</span>:
        ${insuredFacts
					.filter(item => item.type === "hasSpinalMuscularSkeletalDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Arthritis, rheumatism, gout <span class="ff-msjh">關節炎、風濕病、痛風</span>: ${insuredFacts
					.filter(item => item.type === "hasArthritis")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Breast disorder <span class="ff-msjh">乳房疾病</span>: ${insuredFacts
					.filter(item => item.type === "hasBreastDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Any kind of gynecological conditions <span class="ff-msjh">各類型婦科疾病</span>:
        ${insuredFacts
					.filter(item => item.type === "hasGynecologicalConditions")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Disease the Genito-urinary organs <span class="ff-msjh">生殖器與泌尿器之疾病</span>: ${insuredFacts
					.filter(item => item.type === "hasUrinaryDisease")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Venereal disorder, Syphilis <span class="ff-msjh">性病、梅毒</span>: ${insuredFacts
					.filter(item => item.type === "hasVenerealDisorder")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Infection by Human Immunodeficiency Virus (HIV), AIDS <span class="ff-msjh">後天免疫力缺乏症病毒感染、愛滋病</span>:
        ${insuredFacts
					.filter(item => item.type === "hasHivAids")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Diseases/ complications or conditions Associated with pregnancy <span class="ff-msjh">與妊娠有關之疾病或其併發症</span>:
        ${insuredFacts
					.filter(item => item.type === "hasPregnancyComplications")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Mental disorder or psychiatric problems <span class="ff-msjh">精神病</span>: ${insuredFacts
					.filter(item => item.type === "hasPsychiatricProblems")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
        <br>
        Others (other disorders/ diseases not listed) <span class="ff-msjh">其他(任何以上未提及之疾病)</span>:
        ${insuredFacts
					.filter(item => item.type === "hasOtherDisorders")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
      </p>
      <p>
        2. Has the proposed Insured Person ever been in a hospital or clinic for surgery, observation or
        treatment within the last 5 years? <span class="ff-msjh">在過去5年內，準受保人是否曾在醫院或診所內接受手術、診察或治療？</span>${insuredFacts
					.filter(item => item.type === "hasHospitalTreatmentWithinFiveYears")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
      </p>
      <p>
        3. Does the proposed Insured Person know any circumstances for which medical treatment may be necessary
        in the next 12 months? <span class="ff-msjh">準受保人是否知道在未來12個月內需要接受任何醫療的治療？</span>${insuredFacts
					.filter(item => item.type === "hasUpcomingNeedForMedicalTreatment")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
      </p>
      <p>
        4. Is the proposed Insured Person currently under observation or taking any treatment or medication?
        <span class="ff-msjh">準受保人是否現正接受診察、治療或服用藥物？</span>${insuredFacts
					.filter(item => item.type === "hasCurrentNeedForMedication")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
      </p>
      <p>
        5. (For female only) Is the proposed Insured Person now pregnant? <span
          class="ff-msjh">（只適用於女性）準受保人有是否正在懷孕中？</span>${insuredFacts
						.filter(item => item.type === "isCurrentlyPregnant")
						.map(item => {
							return item.value.booleanValue === true ? "Yes" : "No"
						})}
      </p>
      <p>
        6. Has the proposed Insured Person ever experienced of losing weight for more than 5 kg within 6 months?
        <span class="ff-msjh">準受保人是否在6個月內體重下降超過5公斤？</span>${insuredFacts
					.filter(item => item.type === "hasLostWeightWithinSixMonths")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
      </p>
      <p>
        7. Has the proposed Insured Person’s parents or brother or sister who has ever been diagnosed of cancer
        before Age 55? <span class="ff-msjh">準受保人之父母或兄弟姐妹是否曾在55歲之前被診斷為癌症？</span>${insuredFacts
					.filter(item => item.type === "hasCancerDiagnosis")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
      </p>
      <p>
        8. Has the proposed Insured Person or his/her parents or brother or sister ever been refused to cover
        under any form of life or health insurance or ever had a policy rated, modified or renewal refused?
        <span class="ff-msjh">準投保人、其父母或兄弟姐妹曾否投保人壽或醫療保險而被拒絕受保或擁有任何保單經額外加保費或經修改保單條款或被拒續保？</span>${insuredFacts
					.filter(item => item.type === "hasFamilyBeenRejectedInsurance")
					.map(item => {
						return item.value.booleanValue === true ? "Yes" : "No"
					})}
      </p>
    </div>
    <br>
    
    <div class="new-page"></div>
    

    <div>
      <h3>Declaration <span class="ff-msjh">聲明</span></h3>
      The Applicant understands this <span class="ff-msjh">申請人明白</span>:
      <br>
      <ul>
        <li>The applicant agrees to furnish Asia Insurance Company Limited the information in related to the
          eligible persons or insurance plan thereof;
          <span class="ff-msjh">申請人同意提交包括合資格人士和保險計劃的資料給亞洲保險有限公司。</span>
        </li>
        <li>According to the new regulation of Insurance Authority (IA), Premium Levy will be applied on all the
          medical/life policies with effective from 1 Jan 2018.
          <span class="ff-msjh">根據保險業監管局新規條，由2018年1月1日開始，所有醫療及人壽的保單持有人，將需繳付一筆保費徵費。</span>
        </li>
        <li>Any personal information collected by the Company may be used, stored or disclosed to any individual
          or organisation to evaluate this application, to provide our services and products to you, including
          administering, maintaining, managing and operating such services and products, or to provide
          subsequent services. Requests for personal data access or correction may be addressed to Data
          Protection Officer of the Company.
          <span
            class="ff-msjh">本公司所收集的任何個人資料，將用於、儲藏於任何個人及機構以用核實申請，提供服務及產品包括管理、維持、處理及運作有關服務及產品，及提供售後服務的用途。閣下可聯絡本公司的個人資料保護主任，要求更改任何交予本公司的個人資料。</span>
        </li>
        <li>It is our policy to comply with the requirement of the Personal Data (Privacy) Ordinance (Cap. 486)
          of the laws of the Hong Kong Special Administrative Region. The applicant read and agreed the
          Personal Information Collection Statement (“PICS”) at Appendix I of this application form.
          <span class="ff-msjh">本公司會遵守「個人資料（私隱）條例」（香港法例第486章）。申請人已閱讀並同意附錄I中的個人資料收集聲明 (PICS)。</span>
        </li>
      </ul>
      <br>
      The Applicant declare this <span class="ff-msjh">申請人聲明及確認</span>:
      <ul>
        <li>On acceptance of this application by Asia Insurance Company Limited, the policy is to be issued to
          the Policy Holder(s) named in accordance with the information shown on this application.
          <span class="ff-msjh">亞洲保險有限公司一旦接受此申請，保險將根據保單持有人的名義並以本申請表內的資料發行。</span>
        </li>
        <li>I agree that the foregoing answers shall form part of my proposal to the Asia Insurance Company
          Limited, and that the foregoing answer shall also become part of any policy that may be issued on
          the strength thereof.
          <span class="ff-msjh">本人同意上述聲明為已呈交於亞洲保險有限公司之投保書及保單契約法律效力之一部份。</span>
        </li>
        <li>Any other facts known to the Insured Person which are likely to affect acceptance or assessment of
          this insurance cover must be disclosed. Failure to disclose such information may mean that the
          policy will not provide the insured person with the cover the Policy Holder(s) require and may even
          invalidate the policy altogether.
          <span
            class="ff-msjh">受保人必須盡己所知提供所有可能影響亞洲保險有限公司於接納或釐定此保單條文的資料。受保人應如實呈報有關資料，否則保單將可能無法提供閣下所需的保障，甚至可能導致此保單無效。</span>
        </li>
        <li>I hereby authorise any hospital, physician, insurance company or organisation that has any records
          or knowledge of me or my health, to furnish to Asia Insurance Company Limited or its authorised
          representative, any and all information with respect to any illness or injury, medical history,
          consultation prescriptions or treatment and copies of all hospital or medical records for
          application and underwriting purpose. A photostat copy of this authorisation shall be considered as
          effective and valid as the original.
          <span
            class="ff-msjh">本人授權持有本人健康或任何資料之醫院、醫生、保險公司或機構，可以將部份或全部有關本人傷患之病歷、診斷報告及藥方等資料給予亞洲保險有限公司或其代理人作申請及核保之用。此授權書之影印本與正本具同等效力。</span>
        </li>
      </ul>
      I acknowledge that I have read and fully understand the above declaration.
      <span class="ff-msjh">我確認我已閱讀並完全理解上述聲明。</span>
    </div>
    <br>
    <div>
      <h3>Cancellation Rights and Refund of Premium(s) <span class="ff-msjh">取消保單權益及發還保費 </span></h3>
      <p>
        I understand that I have the right to cancel and obtain a refund of any premium(s) paid (less any market
        value adjustments, if any) and any Levy by giving written notice. Such notice must be signed by me and
        received directly by Asia Insurance Company Limited at 8/F 118 Connaught Road West, Sheung Wan, Hong
        Kong within 21 days after the delivery of the policy or issuance of a notice to the Policy Holder or the
        Policy Holder’s representative, whichever is the earlier.
        <span
          class="ff-msjh">本人明白本人有權以書面通知要求取消保單及取回所有已繳保費(扣除市場價值調整，如適用)及保費徵費；但是本人必須簽署該通知，並確保亞洲保險有限公司位於香港上環干諾道西一百一十八號八樓於以下時段內直接收到該通知：保單交付本人或本人的代表後或《通知書》發予本人或本人的代表後，起計的21天，以較先者為準。</span>
      </p>
    </div>
    I acknowledge that I have read and fully understand the above.
    <span class="ff-msjh">我確認我已閱讀並完全理解上述資料。</span>
  </div>
</body>

</html>
    `
}

export { application_form }
